export const GRAPHQL_VARIABLES = {
  newPassword: 'abcd',
  oldPassword: 'abcd'
};

export const QUERY = `
    mutation changePassword ($oldPassword: String!, $newPassword: String!) {
        changePassword (oldPassword: $oldPassword, newPassword: $newPassword) {
            message
        }
    }
`;
